<main class="container-fluid container-fluid-limited main-page settings">
    <div class="settings-sub-header w-100 pt-4 pb-3 border-0">
        <h1 class="team-selector">
            <div class="team-selector-label">
                <i class="far fa-download pe-1"></i> {{'export_title' | translate}}
            </div>
            <tm-team-select baseUrl="/exports"
                            [permission]="permission"
                            [teamIdFromUrl]="teamId"></tm-team-select>
            <small class="d-block pt-3">{{ 'export_menu_desc' | translate }}.</small>
        </h1>
    </div>
    
    <hr class="border-top border-secondary border-1 opacity-25 mt-0 mb-4">

    <section class="row col-md-8 mx-auto mb-4">
        <div class="settings-sub-header w-100 p-2 mb-3">
            <h3><i class="far fa-database"></i> {{ 'export_moods_section' | translate}}
                <small>{{ 'export_moods_section_desc' | translate}}</small>
            </h3>
        </div>
        <article class="media media-hover d-flex justify-content-between align-items-center my-3 px-5 py-4">
            <div class="d-flex">
                <i class="far fa-4x fa-file-alt"></i>
                <div class="ps-4">
                    <h4 class="media-heading">CSV</h4>
                    <p>{{ 'export_csv_description' | translate}}</p>
                </div>
            </div>
            <div>
                <button (click)="export('raw_data', 'csv')" class="btn btn-primary" role="button"><i class="far fa-download"></i> {{ 'export_download' | translate}} CSV
                </button>
            </div>
        </article>
        <article class="media media-hover d-flex justify-content-between align-items-center my-3 px-5 py-4 bg-white">
            <div class="d-flex">
                <i class="far fa-4x fa-file-excel"></i>
                <div class="ps-4">
                    <h4 class="media-heading">Excel</h4>
                    <p>{{ 'export_excel_description' | translate}}</p>
                </div>
            </div>
            <div>
                <button (click)="export('raw_data', 'excel')" class="btn btn-primary" role="button"><i class="far fa-download"></i> {{ 'export_download' | translate}} Excel
                </button>
            </div>
        </article>
    </section>
    
    <section class="row col-md-8 mx-auto mb-4">
        <div class="settings-sub-header w-100 p-2 mb-3">
            <h3><i class="far fa-user-secret"></i> {{ 'export_participation_rates_section' | translate}}
                <small>{{ 'export_participation_rates_section_desc' | translate}}</small>
            </h3>
        </div>
        <article class="media media-hover d-flex justify-content-between align-items-center my-3 px-5 py-4">
            <div class="d-flex">
                <i class="far fa-4x fa-file-alt"></i>
                <div class="ps-4">
                    <h4 class="media-heading">CSV</h4>
                    <p>{{ 'export_csv_description' | translate}}</p>
                </div>
            </div>
            <div>
                <button (click)="export('participation_rates', 'csv')" class="btn btn-primary" role="button"><i class="far fa-download"></i> {{ 'export_download' | translate}} CSV
                </button>
            </div>
        </article>
        <article class="media media-hover d-flex justify-content-between align-items-center my-3 px-5 py-4">
            <div class="d-flex">
                <i class="far fa-4x fa-file-excel"></i>
                <div class="ps-4">
                    <h4 class="media-heading">Excel</h4>
                    <p>{{ 'export_excel_description' | translate}}</p>
                </div>
            </div>
            <div>
                <button (click)="export('participation_rates', 'excel')" class="btn btn-primary" role="button"><i class="far fa-download"></i> {{ 'export_download' | translate}} Excel
                </button>
            </div>
        </article>
    </section>
    
    <section class="row col-md-8 mx-auto mb-4">
        <div class="settings-sub-header w-100 p-2 mb-3">
            <h3><i class="far fa-users"></i> {{ 'export_userlist_section' | translate}}
                <small>{{ 'export_userlist_section_desc' | translate}}</small>
            </h3>
        </div>
        <article class="media media-hover d-flex justify-content-between align-items-center my-3 px-5 py-4">
            <div class="d-flex">
                <i class="far fa-4x fa-file-alt"></i>
                <div class="ps-4">
                    <h4 class="media-heading">CSV</h4>
                    <p>{{ 'export_csv_description' | translate}}</p>
                </div>
            </div>
            <div>
                <button (click)="export('userlist', 'csv')" class="btn btn-primary" role="button"><i class="far fa-download"></i> {{ 'export_download' | translate}} CSV
                </button>
            </div>
        </article>
        <article class="media media-hover d-flex justify-content-between align-items-center my-3 px-5 py-4">
            <div class="d-flex">
                <i class="far fa-4x fa-file-excel"></i>
                <div class="ps-4">
                    <h4 class="media-heading">Excel</h4>
                    <p>{{ 'export_excel_description' | translate}}</p>
                </div>
            </div>
            <div>
                <button (click)="export('userlist', 'excel')" class="btn btn-primary" role="button"><i class="far fa-download"></i> {{ 'export_download' | translate}} Excel
                </button>
            </div>
        </article>
    </section>
</main>



